import { ChangeDetectionStrategy, Component, inject, signal, ViewChild } from "@angular/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { SearchBarComponent } from "../../../shared/components/search-bar-component/search-bar-component";
import { MatCardModule } from "@angular/material/card";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { RenvoiCompagnieData } from "../../model/Suivi";
import { SuiviService } from "../../service/suivi-service";
import { ToastrService } from "../../../shared/services/toastr-service";
import { UpperCasePipe } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { SweetAlertService } from "../../../shared/services/sweet-alert-service";

@Component({
  selector: 'app-renvoi-compagnie-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinner,
    MatCheckboxModule,
    UpperCasePipe,
    MatTabsModule
],
  templateUrl: './renvoi-compagnie-modal.html',
  styleUrl: './renvoi-compagnie-modal.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RenvoiCompagnieModal {

  displayedColumns: string[] = ['assure', 'immat', 'chassis', 'attestation', 'carte_rose', 'periode', 'prix', 'action'];
  dataSource : MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  readonly dialog = inject(MatDialog);

  readonly data = inject<RenvoiCompagnieData>(MAT_DIALOG_DATA);

  loading : boolean = false

  renvoiData : any[] = []

  constructor(
    private suiviService : SuiviService,
    private toastrService : ToastrService,
    private sweetAlertService : SweetAlertService
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadREnvoiDetails()
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadREnvoiDetails(){
    this.loading = true
    this.suiviService.renvoiCompagnieDetails(this.data.compagnie_id, this.data.collaborateur_id)
    .subscribe({
      next : (res) => {
        this.loading = false
        this.dataSource.data = res
        //this.toastrService.success("succes")
      },
      error : (err) =>{
        this.loading = false
        this.toastrService.error("Une erreur est survenue")
      }
    })
  }


   selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.renvoiData = []
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
    this.renvoiData = this.dataSource.filteredData.slice()
  }

  selectAssurance(row : any){
    if(this.renvoiData.findIndex(item => item.id == row.id) == -1 && this.selection.isSelected(row)){
      this.renvoiData.push(row)
    }else{
      this.renvoiData.splice(this.renvoiData.findIndex(item => item.id == row.id), 1)
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return ``;
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onRenvoi(){
    this.sweetAlertService.confirm("Etez-vous sur de vouloir effectuer cette opreation ?", "Confirmation")
    .then((res) =>{
      if(res.isConfirmed){
        this.suiviService.renvoiDocuments(this.renvoiData).subscribe({
          next : (res) =>{
            this.renvoiData.splice(0, this.renvoiData.length)
            this.selection.clear();
            this.loadREnvoiDetails()
            this.toastrService.success()
          },
          error : (err) =>{
            this.toastrService.error("Une erreur est survenue")
          }
        })
      }
    })

  }
}